<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:desc>
      <company-risks-count :company-count-data="companyCountData" />
    </template>
    <template v-slot:filter>
      <company-risks-fitter :fitter="searchObj" @search="handleSearch" />
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading" @cell-click="handleCellClick" />
    <template v-slot:drawer>
      <risks-drawer :drawer="risksDrawer" :drawer-title="risksDrawerTitle" @handleClose="handleRisksClose" :company="company" />
      <company-info-drawer :drawer="companyInfoDrawer" :drawer-title="companyInfoDrawerTitle" @handleClose="handleCompanyInfoClose" :company-name="drawerCompanyName"/>
    </template>
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import CompanyRisksFitter from './common/CompanyRisksFitter'
import RisksDrawer from './common/RisksDrawer'
import CompanyInfoDrawer from "./common/CompanyInfoDrawer"
import PhoneInfo from "./common/PhoneInfo.vue"
import UserOrder from "./common/UserOrder.vue"
import CompanyRisksCount from "./common/CompanyRisksCount.vue"
export default {
  name: 'CompanyRisks',
  components: {
    ResourceListLayout,
    ResourceListPageContent,
    CompanyRisksFitter,
    RisksDrawer,
    CompanyInfoDrawer,
    CompanyRisksCount
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  computed: {
    searchStr: function () {
      let resultArray = Object.values(this.searchObj)
      let jsonStr = JSON.stringify(resultArray)

      return '&searchArr=' + jsonStr
    }
  },
  data () {
    return {
      title: '企业风险专题',
      searchObj: {
        select_key: '',
        company_name: { select_key: 'company_name', key: '', type: 'text', selectType: 'clue' },
        is_wechat: { select_key: 'is_wechat', key: '', type: 'is_or_null', selectType: 'clue' },
        phone: { select_key: 'phone', key: '', type: 'json_is_null', selectType: 'clue' },
        xlb_phone: { select_key: 'xlb_phone', key: '', type: 'json_is_null', selectType: 'clue' },
        self_phone: { select_key: 'self_phone', key: '', type: 'json_is_null', selectType: 'clue' },
        user_id: { select_key: 'user_id', key: '', type: 'is_null', selectType: 'clue' },
        order_id: { select_key: 'order_id', key: '', type: 'is_null', selectType: 'clue' },
        is_business: { select_key: 'is_business', key: '', type: 'is_or_null', selectType: 'clue' },
        executor: { select_key: '案号', key: '', type: 'text', selectType: 'dimensionality' },
        docNum: { select_key: '决定文书号', key: '', type: 'text', selectType: 'dimensionality' },
        filingDate: { select_key: '立案日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        releaseDate: { select_key: '发布日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        finaDate: { select_key: '终本日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        process: { select_key: '进程日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        caseType: { select_key: '案件类型', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        refereeDate: { select_key: '裁判日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        unit: { select_key: '处罚单位', key: '', type: 'text', selectType: 'dimensionality' },
        register_status: { select_key: '登记状态', key: '', type: 'selectMultiple', selectType: 'dimensionality', is_base: 1 },
        create_year: { select_key: '成立日期', key: '', type: 'date_year', selectType: 'dimensionality', is_base: 1 },
        region: { select_key: '所属区县', key: '', type: 'selectMultipleIn', selectType: 'dimensionality', is_base: 1 },
      },
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      loading: false,
      cols: [
        { label: 'id', prop: 'id', fixed: true },
        { label: '企业名称', prop: 'company_name', clickable: true, fixed: true, width: '240' },
        { label: '企业状态', prop: 'basic_info.info.登记状态', width: '120' },
        { label: '失信被执行人', prop: '失信被执行人', clickable: true, width: '120' },
        { label: '终本案件', prop: '终本案件', clickable: true },
        { label: '司法案件', prop: '司法案件', clickable: true },
        { label: '限制高消费', prop: '限制高消费', clickable: true, width: '100' },
        { label: '被执行人', prop: '被执行人', clickable: true },
        { label: '裁判文书', prop: '裁判文书', clickable: true },
        { label: '行政处罚', prop: '行政处罚', clickable: true },
        { label: '法人', prop: 'basic_info.info.法定代表人'},
        { label: '手机号', prop: 'phone', component: PhoneInfo, width: '205'},
        { label: '手机号（渠道拉取）', prop: 'xlb_phone', component: PhoneInfo, width: '205'},
        { label: '手机号（清洗后）', prop: 'self_phone', component: PhoneInfo, width: '205'},
        { label: '会员/订单', prop: '', width: '120', component: UserOrder},
      ],
      risksDrawer: false,
      risksDrawerTitle: '',
      company: {},
      companyInfoDrawerTitle: '企业信息',
      companyInfoDrawer: false,
      drawerCompanyName: '',
      companyCountData: [
        { label: '有风险信息的企业', value: 0 },
        { label: '失信被执行人', value: 0 }
      ]
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/upload_tasks/company_risks?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    getCountData () {
      this.$axios.get('/api/admin/upload_tasks/company_risks/count', { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyCountData = data.data
          }
        })
    },
    handleCellClick({ row, prop }) {
      if (prop === 'company_name') {
        this.drawerCompanyName = row.company_name
        this.companyInfoDrawer = true
        this.companyInfoDrawerTitle = row.company_name
      } else {
        this.company = { company_name: row.company_name, key: prop }
        this.getRisksInfo({ company_name: row.company_name, key: prop })
      }
    },
    getRisksInfo (company) {
      this.company = company
      this.risksDrawerTitle = company.company_name + '--' + company.key
      this.risksDrawer = true
    },
    handleSearch (search) {
      this.resetCurrentPage()
    },
    resetCurrentPage () {
      if (this.pageOption.currentPage === 1) {
        this.fetchData()
        return
      }
      this.pageOption.currentPage = 1
    },
    handleRisksClose (drawer) {
      this.risksDrawer = drawer
    },
    handleCompanyInfoClose (drawer) {
      this.companyInfoDrawer = drawer
    }
  },
  mounted () {
    this.fetchData()
    this.getCountData()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company_risks/CompanyRisks.vue